export default __webpack_public_path__ + "static/media/ca_2.d114a1f7.png";